module.exports = __webpack_public_path__ + "img/boxing.bddb56c9.svg";